<template>
    <v-form class="overwrite-inputs" ref="payform" v-model.trim="validPaymentForm" lazy-validation>
        <input type="hidden" id="securefieldcode" name="SecuredCardData" :value="SecuredCardData" />
        <v-flex xs12 sm12 md12>
            <div class="theme--light v-text-field v-text-field--is-booted mt-0 pt-0">
                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <div id="eway-secure-field-name" class="eway-fields" style="height: 54px; width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <v-text-field label="Card Number" v-model.trim="cardNumber" :rules="cardNumberRules" required></v-text-field> -->
        </v-flex>
        <v-flex xs12 sm12 md12>
            <div class="theme--light v-text-field v-text-field--is-booted">
                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <div id="eway-secure-field-card" class="eway-fields" style="height: 54px; width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <v-text-field label="Full Name" v-model.trim="cardHolder" :rules="cardHolderRules" required></v-text-field> -->
        </v-flex>
        <v-flex xs12 sm12 md12>
            <div class="theme--light v-text-field v-text-field--is-booted">
                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <div id="eway-secure-field-expiry" class="eway-fields" style="height: 54px; width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <v-text-field label="Card Expiry" v-model.trim="cardExpiry" :rules="cardExpiryRules" v-mask="'##/##'" hint="MM/YY" persistent-hint required></v-text-field> -->
        </v-flex>
        <v-flex xs12 sm12 md12>
            <div class="theme--light v-text-field v-text-field--is-booted">
                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <div id="eway-secure-field-cvn" class="eway-fields" style="height: 54px; width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <v-text-field label="CVC" v-model.trim="cardCvc" :rules="cardCvcRules" required></v-text-field> -->
        </v-flex>
        <v-alert v-model="paymentAlert" dismissible dense outlined text type="error" class="mt-4 mb-0">Credit Card fields invalid.</v-alert>
    </v-form>
</template>

<script>
import { EventBus } from "@shared/EventBus.js";

export default {
    name: "Eway",
    data() {
        return {
            SecuredCardData: "",
            paymentAlert: false,
            errorPaymentEway: {},
            ewayAlreadyLoaded: false,
            validPaymentForm: false,
        };
    },
    methods: {
        clearPay() {
            this.paymentAlert = false;
            this.getEwayFields();
        },
        submitPay: function() {
            if (this.SecuredCardData != "") {
                this.validPaymentForm = false;
                this.paymentProcessing = true;

                const SecuredCardData = this.SecuredCardData;

                this.$emit("submitted-pay", { SecuredCardData });
            } else {
                this.paymentAlert = true;
            }
        },
        getEwayFields() {
            this.validPaymentForm = false;

            document.getElementById("eway-secure-field-name").innerHTML = "";
            document.getElementById("eway-secure-field-card").innerHTML = "";
            document.getElementById("eway-secure-field-expiry").innerHTML = "";
            document.getElementById("eway-secure-field-cvn").innerHTML = "";

            // let publicApiKey = process.env.MIX_EWAY_PUBLIC_API_KEY;
            let publicApiKey = gtwPwEwKey;

            let fieldStyles =
                "border-radius: 0; height: 48px; padding: 8px 0px 0px; background-color: #fafafa; border: 0px solid #fafafa; font-size: 16px; font-family Roboto, sans-serif; line-height: 20px; color: #444; width: 100%; outline: 0; color: rgba(0,0,0,.87); box-shadow: none;";

            let nameFieldConfig = {
                publicApiKey: publicApiKey,
                fieldDivId: "eway-secure-field-name",
                fieldType: "name",
                styles: fieldStyles,
                needsSave: false,
            };
            let cardFieldConfig = {
                publicApiKey: publicApiKey,
                fieldDivId: "eway-secure-field-card",
                fieldType: "card",
                styles: fieldStyles,
                needsSave: false,
            };
            let expiryFieldConfig = {
                publicApiKey: publicApiKey,
                fieldDivId: "eway-secure-field-expiry",
                fieldType: "expirytext",
                styles: fieldStyles,
                needsSave: false,
            };
            let cvnFieldConfig = {
                publicApiKey: publicApiKey,
                fieldDivId: "eway-secure-field-cvn",
                fieldType: "cvn",
                styles: fieldStyles,
                needsSave: false,
            };

            let vueJs = this;

            function secureFieldCallback(event) {
                if (!event.valueIsValid) {
                    // console.log(event);
                    // vueJs.$set(vueJs.errorPaymentEway, event.targetField, event.valueIsValid);
                    vueJs.paymentAlert = true;
                } else {
                    // vueJs.$set(vueJs.errorPaymentEway, event.targetField, true);

                    // set the hidden Secure Field Code field
                    let s = document.getElementById("securefieldcode");
                    s.value = event.secureFieldCode;
                    vueJs.SecuredCardData = event.secureFieldCode;
                }
            }

            // if (this.ewayAlreadyLoaded) {
            //     eWAY.setupSecureField(nameFieldConfig, secureFieldCallback);
            //     eWAY.setupSecureField(cardFieldConfig, secureFieldCallback);
            //     eWAY.setupSecureField(expiryFieldConfig, secureFieldCallback);
            //     eWAY.setupSecureField(cvnFieldConfig, secureFieldCallback);

            //     vueJs.validPaymentForm = true;
            // } else {
                let ewayScript = document.createElement("script");
                ewayScript.setAttribute("src", "https://secure.ewaypayments.com/scripts/eWAY.min.js");
                ewayScript.async = true;
                ewayScript.onload = () => {
                    eWAY.setupSecureField(nameFieldConfig, secureFieldCallback);
                    eWAY.setupSecureField(cardFieldConfig, secureFieldCallback);
                    eWAY.setupSecureField(expiryFieldConfig, secureFieldCallback);
                    eWAY.setupSecureField(cvnFieldConfig, secureFieldCallback);

                    vueJs.validPaymentForm = true;
                    vueJs.ewayAlreadyLoaded = true;
                };
                document.head.appendChild(ewayScript);
            // }
        },
    },
    mounted() {
        this.getEwayFields();
    },
    created() {
        EventBus.$on("clear-pay", this.clearPay);
        EventBus.$on("submit-pay", this.submitPay);
    },
    beforeDestroy() {
        EventBus.$off("clear-pay");
        EventBus.$off("submit-pay");
    },
};
</script>

<style scoped></style>
